/*
 * Created by Anup Shrestha (anup.stha012@gmail.com)
 * Copyright (c) 2022.  All rights reserved.
 * Last modified 5/10/22, 11:19 AM
 *
 */

import DropdownController from 'components/DropdownController/DropdownController';

export default DropdownController;
